import type {
  queueInterface,
  rtcInfoInterface
} from '@/types/viewsType/socketType'
import type { memberListInterface } from '@/types/apiType/roomType'
import type {
  volumeIndicatorSDKInterface,
  volumeIndicatorMapInterface
} from '@/types/viewsType/roomType'

export const useAudioStore = defineStore({
  id: 'audio',
  state: () => ({
    /** 扬声器,IOS || webView 默认false，其他true*/
    isOpenSound: true,
    /**  是否打开本地麦克风, isOpenLocalMin 开启了，isOpenMic才可以开启 */
    isOpenLocalMin: true,
    /** 自己是否已经在麦上 */
    isOnMicSeat: false,
    /**  麦克风 */
    isOpenMic: true,
    seats: 10, //麦位数量
    /** 麦位列表 */
    queueList: defaultData.defaultQueueList() as queueInterface[], //
    charmList: {}, //麦位魅力值 { uid: value }
    /** 是否是管理员 */
    inMicMembers: [] as memberListInterface[], //在麦成员
    /** 语音房推流token */
    rtcInfoMin: {} as rtcInfoInterface,
    volumeIndicatorMap: {} as volumeIndicatorMapInterface // 音量指标数组
    // 直播RTC SDK配置信息
  }),
  getters: {
    /** 当前麦位否被禁麦 */
    isLockMic(state) {
      const userStore = useUserStore()
      return Boolean(
        state.queueList.find(
          (v) => v.value.member?.uid === userStore.userInfo.uid
        )?.value.mic_info.micState
      )
    },
    /** 用户自己是否在麦位上 */
    // isOnMicSeat(state) {
    //   const userStore = useUserStore()
    //   return (
    //     state.queueList.findIndex(
    //       (v) => v.value.member?.uid === userStore.userInfo.uid
    //     ) !== -1
    //   )
    // },
    /** 在麦用户列表 */
    inMicQueueList(state): queueInterface[] {
      return state.queueList.filter((item) => {
        return item.value.member
      })
    }
  },
  actions: {
    /**
     * 设置音量指标数组
     * 将数组转对象,因腾讯和声网字段不一致，所以需要过滤
     */
    setVolumeIndicator(list: volumeIndicatorSDKInterface[]) {
      const userStore = useUserStore()
      const obj = {} as volumeIndicatorMapInterface
      list.forEach((v) => {
        let uid = Number(v.uid || v.userId || 0)
        const volume = v.level || v.volume || 0
        // 腾讯兼容性，如果是0，那就是用户自己
        if (uid === 0) {
          uid = userStore.userInfo.uid
        }
        obj[uid] = {
          uid,
          volume
        }
      })
      this.volumeIndicatorMap = obj
    },
    /** 设置rtcInfo */
    setRtcInfoMic(rtcInfo: rtcInfoInterface) {
      this.rtcInfoMin = rtcInfo
    },
    // 初始化麦位列表等信息
    initData(data) {
      console.log('🚀 ~ file: audio.ts:87 ~ data:', data)
      const userStore = useUserStore()
      this.setSeats(data.room_info.seats) //麦位数量
      this.queueList = data.queue_list.slice(1) //麦位列表
      userStore.setUserInfo(data.member)
      console.log('🚀 ~ file: audio.ts:105 ~ data.member:', data.member)
      // 更新自己的状态字段
      const queue = data.queue_list.find(
        (v) => v.key !== -1 && v.value.member?.uid === data.member.uid
      )
      this.isOnMicSeat = !!queue //用户自己是否在麦位上
      console.log(
        '🚀 ~ file: audio.ts:97 ~ this.isOnMicSeat:',
        this.isOnMicSeat
      )

      // 过滤麦位列表,获取当前在麦成员
      this.getInMicMembers()
    },
    /** 设置麦位数量 */
    setSeats(seats: number) {
      if (seats) {
        this.seats = seats
      }
    },
    // 麦位或主播位成员列表发生变化
    onQueueMemberUpdateNotice(data) {
      /*
        key 麦位排序
        min_info 麦位信息
        value 麦位用户信息
        type 1上麦 2下麦
        connect_mic_type 0语音 1视频 2invalid 3PK
      */
      // const micApplyStore = useMicApplyStore()
      const userStore = useUserStore()
      const { userInfo } = userStore
      const queueListItem = this.queueList?.[data.key]
      if (queueListItem?.value) {
        if (data.type === 1) {
          // 处理麦位消息
          queueListItem.value.member = data.value
          queueListItem.value.mic_info = data.mic_info

          //如果是自己上麦 就发布本地音频轨道
          if (data.value.uid === userInfo.uid) {
            this.isOnMicSeat = true
            // 如果之前是关闭的就一直关闭，开启的就取麦位状态
            // this.manageLocalAudioMicrophone(!data.mic_info.micState)
            // micApplyStore.setMicApplyCallbackType(1)
          }
        } else if (data.type === 2) {
          // 处理麦位消息
          queueListItem.value.member = null
          queueListItem.value.mic_info = data.mic_info
          //如果是自己下麦 就取消发布本地音频轨道
          if (data.value.uid === userInfo.uid) {
            this.isOnMicSeat = false
            // this.manageLocalAudioMicrophone(false)
          }
        }
      }

      // 过滤麦位列表,获取当前在麦成员
      this.getInMicMembers()
    },
    // 麦位魅力值推送通知
    onRoomMicCharmPush(data) {
      const { dataList } = data.custom.data
      dataList.forEach((value: { uid: number; charmValue: number }) => {
        this.charmList[value.uid] = value.charmValue
      })
    },
    //麦位状态更新
    onQueueMicUpdateNotice(data) {
      console.log('🚀 ~ file: audio.ts:162 ~ data:', data)
      const { userInfo } = useUserStore()

      // 如果是-1就不处理，在视频房主播是-1
      if (data.key === -1) return

      /** 拿来比较是否是自己uid */
      // let memberUid = 0
      if (typeof data.mic_info === 'string') {
        data.mic_info = JSON.parse(data.mic_info)
        // 先存uid
        // memberUid = this.queueList[data.key].value.member?.uid || 0
        // 返回string类型要清空当前麦位的用户信息
        this.queueList[data.key].value.member = null
      }

      this.queueList[data.key].value.mic_info = data.mic_info

      // 如果是自己
      if (this.queueList[data.key].value.member?.uid === userInfo.uid) {
        // 如果之前是关闭的就一直关闭，开启的就取麦位状态
        console.log(
          '🚀 ~ file: audio.ts:184 ~ data.mic_info.micState:',
          data.mic_info.micState
        )
        // this.manageLocalAudioMicrophone(!data.mic_info.micState)
      }

      // 过滤麦位列表,获取当前在麦成员
      this.getInMicMembers()
    },
    // 上麦
    updateQueue(index, isInvite?: boolean) {
      const roomStore = useRoomStore()
      // 如果不是管理员角色 麦位被锁住了 return回去
      if (
        this.queueList[index].value.mic_info.posState &&
        !(
          roomStore.userMemberInfo.is_manager ||
          roomStore.userMemberInfo.is_creator
        )
      )
        return

      const socketStore = useSocketStore()
      const userStore = useUserStore()

      const roomId = roomStore.roomId
      const position = index
      const uid = userStore.userInfo.uid
      if (
        (roomStore.userMemberInfo.is_manager ||
          roomStore.userMemberInfo.is_creator) &&
        !isInvite
      ) {
        AppNative.appFun(AppNative.iosNeedMessageFun.creatorUpdateQueue, index)
      } else {
        // 发送上麦socket
        socketStore.privateSend(
          {
            route: socketRequestRoute.updateQueue,
            req_data: {
              room_id: roomId,
              key: position,
              uid,
              videoChannel: roomStore.socketRoomInfo.videoChannel || 0
            }
          },
          true
        )
      }
    },
    // 下麦
    pollQueue(index) {
      const socketStore = useSocketStore()
      const roomStore = useRoomStore()
      const roomId = roomStore.roomId
      const position = index

      // 发送下麦socket
      socketStore.privateSend(
        {
          route: socketRequestRoute.pollQueue,
          req_data: {
            room_id: roomId,
            key: position
          }
        },
        true
      )
    },
    // 过滤麦位列表,获取当前在麦成员
    getInMicMembers() {
      const arr: memberListInterface[] = []
      this.queueList.forEach((item) => {
        if (item.value.member) arr.push(item.value.member)
      })
      this.inMicMembers = arr
    },
    // 设置管理员通知
    onChatRoomManagerAdd(data) {
      const userStore = useUserStore()
      const roomStore = useRoomStore()
      const { userInfo } = userStore
      const member = data.member
      this.queueList.forEach((item) => {
        if (item.value.member && item.value.member.uid === member.uid) {
          item.value.member.is_manager = true

          // 是自己的话
          if (userInfo.uid === member.uid) {
            roomStore.setUserMemberInfoKeyValue('is_manager', true)
            const i18n = useNuxtApp().$i18n
            showToast(i18n.t('audio.setManageTips'))
          }
        }
      })
    },
    // 移除管理员通知
    onChatRoomManagerRemove(data) {
      const userStore = useUserStore()
      const roomStore = useRoomStore()
      const { userInfo } = userStore
      const member = data.member
      this.queueList.forEach((item) => {
        if (item.value.member && item.value.member.uid === member.uid) {
          item.value.member.is_manager = false

          // 是自己的话
          if (userInfo.uid === member.uid) {
            roomStore.setUserMemberInfoKeyValue('is_manager', false)
            const i18n = useNuxtApp().$i18n
            showToast(i18n.t('audio.removeManageTips'))
          }
        }
      })
    },
    // 邀请上麦通知
    onInviteMessage(data) {
      const userStore = useUserStore()
      const { userInfo } = userStore
      // 收到的是用户自己被邀请就上麦
      if (userInfo.uid == data.uid) {
        this.updateQueue(data.micPosition, true)
        const i18n = useNuxtApp().$i18n
        showToast(i18n.t('audio.inviteSuccessTips'))
      }
    },
    // 开关声音
    switchAllRemoteAudioTrack(isOpenSound: boolean) {
      const roomStore = useRoomStore()
      const agoraStore = useAgoraStore()
      const trtcStore = useTrtcStore()
      console.log(
        '🚀 ~ file: audio.ts:296 ~ roomStore.rtcInfo:',
        roomStore.rtcInfo
      )
      if (roomStore.rtcInfo.rtcType === 'AGORA') {
        if (!agoraStore.joined) return
        this.setIsOpenSound(isOpenSound)
        agoraStore.switchAllRemoteAudioTrack(isOpenSound)
      } else {
        if (!trtcStore.joined) return
        this.setIsOpenSound(isOpenSound)
        trtcStore.switchAllRemoteAudioTrack(isOpenSound)
      }
    },
    // 开关麦克风
    manageLocalAudioMicrophone(isOpenMic: boolean) {
      console.log('🚀 ~ file: audio.ts:315 ~ isOpenMic:', isOpenMic)
      const roomStore = useRoomStore()
      const agoraStore = useAgoraStore()
      const trtcStore = useTrtcStore()
      if (roomStore.rtcInfo.rtcType === 'AGORA') {
        if (!agoraStore.joined) return
        this.isOpenMic = this.isOpenLocalMin && isOpenMic
        agoraStore.manageLocalAudioMicrophone(this.isOpenMic)
      } else {
        if (!trtcStore.joined) return
        this.isOpenMic = this.isOpenLocalMin && isOpenMic
        trtcStore.manageLocalAudioMicrophone(this.isOpenMic)
      }
    },
    /**
     * 服务端渲染初始化isOpenSound
     */
    initIsOpenSound() {
      this.isOpenSound =
        !(common.checkVersion().ios || common.checkVersion().webView) ||
        common.checkVersion().app
    },
    /**
     * 设置扬声器是否打开
     */
    setIsOpenSound(value: boolean) {
      this.isOpenSound = value
    },
    /**
     * 设置麦克风是否打开
     */
    setIsOpenMic(value: boolean) {
      this.isOpenMic = value
    },
    /**
     * 设置本地麦克风是否打开
     */
    setIsOpenLocalMin(value: boolean) {
      this.isOpenLocalMin = value
    },
    // 重置数据
    resetData() {
      this.seats = 10
      this.isOpenLocalMin = true
      this.isOpenMic = true
      this.isOnMicSeat = false
      this.rtcInfoMin = {} as rtcInfoInterface
      this.queueList = defaultData.defaultQueueList()
      this.inMicMembers = []
      this.volumeIndicatorMap = {}
      this.charmList = {}
      this.setIsOpenSound(
        !(common.checkVersion().ios || common.checkVersion().webView) || // eslint-disable-next-line prettier/prettier
          common.checkVersion().app
      )
    }
  }
})
